module.exports = __webpack_public_path__ + "static/img/11.98c21d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/11.png
// module id = Fn7N
// module chunks = 0